import Vue from 'vue'
import Vuex from 'vuex'

// Global
import mutations from './mutations'
import actions from './actions'

import { EVALUATION_VIEW_TYPE_CHOICES } from '@/utils/constants'

Vue.use(Vuex)

// Global state (Used all over the application)
const state = {
  toasts: [],
  evaluationViewType: EVALUATION_VIEW_TYPE_CHOICES.BY_STUDENT,
}

const store = {
  state,
  actions,
  mutations,
}

export default new Vuex.Store({
  ...store,
})
